import React, { useEffect, useState, useCallback } from "react";
import { connect } from 'react-redux';
import Form from 'react-bootstrap/Form';
import Graph from '../../components/Graph';
import { MdClear, MdSearch } from 'react-icons/md';
import { FaPrint } from 'react-icons/fa';
import { FaCalendarAlt,
        FaMotorcycle,
        FaCarSide,
        FaShuttleVan,
        FaTruckPickup,
        FaTruck,
        FaBus,
        FaTruckMoving,
        FaRegQuestionCircle
        } from 'react-icons/fa';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { API } from 'aws-amplify';
import moment from 'moment';

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

import SpeedReportXls from './SpeedReportXls';
import { useToasts } from 'react-toast-notifications';

import "./SpeedReport.scss";

const params = {
    headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
}

const SpeedReport = (props) => {
    const { addToast } = useToasts();
    const [vehClass, setVehClass] = useState('ALL');
    const [vehicleCount, setVehicleCount] = useState({});
    const [vehicleCountTbl, setVehicleCountTbl] = useState([]);
    const [numDays, setNumDays] = useState(0);
    const [asset, setAsset] = useState();
    const [assets, setAssets] = useState([]);
    const [assetName, setAssetName] = useState();
    const [timeFrom, setTimeFrom] = useState(new Date().setHours(0,0,0));
    const [timeTo, setTimeTo] = useState(new Date().setHours(23,59,0));
    const [dateSel, setDateSel] = useState(new Date());
    const [dateSelTo, setDateSelTo] = useState(new Date());
	const [isLoading, setIsLoading] = useState(false);
	const [isLoadingCounts, setIsLoadingCounts] = useState(false);
    const [counts, setCounts] = useState([]);
    const [speedTime, setSpeedTime] = useState({});
    const [speedTimeTbl, setSpeedTimeTbl] = useState([]);
    const [speedV85, setSpeedV85] = useState({});
    const [speedV85Tbl, setSpeedV85Tbl] = useState([]);
    const [maxSpeed, setMaxSpeed] = useState({});
    const [maxSpeedTbl, setMaxSpeedTbl] = useState([]);
    const [avgSpeedWeekday, setAvgSpeedWeekday] = useState({});
    const [avgSpeedWeekdayTbl, setAvgSpeedWeekdayTbl] = useState([]);
    const [adt, setADT] = useState({});
    const [adtTbl, setADTTbl] = useState([]);
    const [speedUnit, setSpeedUnit] = useState();

	const [location, setLocation] = useState('');
	const [locationList, setLocationList] = useState([]);
	const [assetList, setAssetList] = useState([]);
    const [countryList, setCountryList] = useState([]);
	const [country, setCountry] = useState('');
    const chartColors = process.env.REACT_APP_CHART && process.env.REACT_APP_CHART.split(',');  
    const [error, setError] = useState('');

    const WEEKDAY = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
    let vClass = process.env.REACT_APP_CLASS && process.env.REACT_APP_CLASS.split(',');    
    vClass = vClass.map(i => i.trim())

    let formatDate = ['DD-MM-YYYY','dd/MM/yyyy','DD/MM/YYYY, h a', 'DD-MM', 'HH:00']
    if (props.formatDate!==formatDate[0]){
        formatDate = ['MM-DD-YYYY','MM/dd/yyyy','MM/DD/YYYY, h a', 'MM-DD', 'HH:00']
    }

    const sum = (arr) => arr.reduce((a, b) => a + b, 0);
    const count_non_zeros = (arr) => arr.reduce((a, b) => b > 0 ? a + 1 : a, 0);
    const avg_excluding_zeros = useCallback((arr) => {
        if (!Array.isArray(arr) || arr.length === 0) {
        return 0;
        }
        const non_zeros = count_non_zeros(arr);
        if (non_zeros === 0) {
        return 0;
        }
        return parseFloat((sum(arr) / non_zeros).toFixed(2));
    },[]);

    const max_number = useCallback((arr) => {
        if (!Array.isArray(arr) || arr.length === 0) {
        return 0;
        }
        const max = Math.max(...arr)
        return parseFloat(max).toFixed(2);
    },[]);

    const percentil_85 = useCallback((arr) => {
        if (!Array.isArray(arr) || arr.length === 0) {
            return 0;
        }

        // Step 1: Sort the array in ascending order
        arr.sort((a, b) => a - b);
        // Step 2: Calculate the index of the 85th percentile value
        const index = Math.ceil(0.85 * arr.length) - 1;
        // Step 3: Retrieve the value at that index
        return parseFloat(arr[index]).toFixed(2);
    },[]);

    // Load asset
    /* eslint-disable no-alert, no-console */
    useEffect(()=>{
        const fetchAssets = async () => {
            setIsLoading(true);

            const data = await API.get('asset','/', params)
            data.sort((a, b) => (a.name > b.name) ? 1 : -1)

            //Get user asset list
            // let user_assets = []
            // if (props.user && props.user.username)
            //     user_assets = await API.get('user_assets','/' + props.user.username, params)
            let user_assets = props.user.user_assets || []

            let assetsFiltered = []
            if (user_assets){
                // user_assets = user_assets.assets;
                assetsFiltered = data.filter(x => user_assets.find(i => i === x.id) && x.status === 'active');
            }

            if (assetsFiltered.length>0){
                setAssets(assetsFiltered);
                setAssetList(assetsFiltered);
            }

            setIsLoading(false);
        }

        if (props.user && props.user.user_assets)
            fetchAssets();

    }, [props.user]);

    // Load counts
    // Fetch hourly counts filter by asset, date and time range
    const fetchCounts = async () => {
        setIsLoadingCounts(true);
        setCounts([]);

        const dtF = new Date(dateSel)
        const dtT = new Date(dateSelTo)

        const dtFrom = moment.utc(dtF).local().format('YYYY-MM-DD')
        const tiFrom = moment.utc(timeFrom).local().format('HH:mm:ss');
        let  dateStart = moment(dtFrom + ' ' + tiFrom).toISOString();

        const dtTo = moment.utc(dtT).local().format('YYYY-MM-DD')
        const tiTo = moment.utc(timeTo).local().format('HH:mm:ss');
        let  dateEnd = moment(dtTo + ' ' + tiTo).toISOString();

        const diffTime = Math.abs(dtT - dtF);
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); 

        setNumDays(diffDays)

        if (dateEnd >= dateStart){

            let data = []
            if (dateEnd >= dateStart){
                const filter = asset +'?start='+ dateStart +'&end='+ dateEnd +'&class=' + vehClass //+'&class=' //+ vehClass

                // HOURLY COUNT
                await API.get('hourly_counts_speed','/'+ filter, params)
                .then(resp => {
                    data = resp

                    const selAsset = assets.find(x => x.id === asset)
                    setAssetName(selAsset.name);
                    setIsLoadingCounts(false);
                    setSpeedUnit(selAsset.speed)

                    setCounts(data);

                }).catch(error => {
                    console.log(error)
                    addToast('Error Loading Data', { appearance: 'error' });
                    setIsLoadingCounts(false);
                });      

            } else {
                addToast('Error incorrect dates', { appearance: 'error' });
            }
        }

    }

   // Load country
   useEffect(()=>{
    const fetchCountry = async () => {
        let loc = [...new Set(assets.map(item => item.country))];
        loc = loc.filter(item => item !== undefined);
        loc.sort((a, b) => (a > b) ? 1 : -1)
        if (loc.length === 1)
            setCountry(loc[0]);

        setCountryList(loc);
    }
    fetchCountry();

    }, [assets]);

    // Load location
    useEffect(()=>{
    const fetchLocation = async () => {
        let loc=[]
        if (country){
            loc = [...new Set(assets.filter(item => item.country === country).map(item => item.location))];
        }else{
            loc = [...new Set(assets.map(item => item.location))];
        }
        loc = loc.filter(item => item !== undefined);
        loc.sort((a, b) => (a > b) ? 1 : -1)
        setLocationList(loc);
    }
    fetchLocation();
    }, [assets, country]);

    useEffect(() => {
        const handleSearch = () => {
            let results = assets;
            // country
            if (country){
                results = results.filter(results =>
                    results.country && results.country.toLowerCase().includes(country.toLowerCase())
            )}
            // Location
            if (location){
                results = results.filter(results =>
                    results.location && results.location.toLowerCase().includes(location.toLowerCase())
            )}
            setAssetList(results);
        }
		handleSearch();
    }, [location, country, assets]);


// SPEED START
    // --------------------------
    useEffect(() => {
        // Speed
        const getAvgSpeed = () => {

            let arrByHour = [];
            let arrByHourV85 = [];
            let arrByDayMaxSpeed = [];
            let arrByWeekDayAvgSpeed = [];
            let arrByDayAvgCount = [];

            let speed_unit = 1
            // console.log(speedUnit)
            switch (speedUnit){
                case 'ms':
                    speed_unit = 3.6
                    break;
                case 'mph':
                    speed_unit = 1.60934
                    break;
                default:
                    speed_unit = 1
            }

            //Filter Vehicles SPEED. Exclude PEDESTRIANS
            for (let i = 0; i < counts.length; i++){
                           
                let arrSpeed = counts[i]
                arrSpeed.SPEED = parseFloat(arrSpeed.SPEED * speed_unit).toFixed(2)
                arrSpeed.MAX_SPEED = parseFloat(arrSpeed.MAX_SPEED * speed_unit).toFixed(2)
                arrSpeed.P85_SPEED = parseFloat(arrSpeed.P85_SPEED * speed_unit).toFixed(2)

                // console.log(arrSpeed)
                let avg = {}
                let max = {}
                let avgSpeedDay = {}
                let v85 = {}
                let avgCountDay = {}

                if (arrSpeed.SPEED > 0){
                    // AVG SPEED / HOUR
                    avg = {
                        date_iso: moment(new Date(arrSpeed.date_iso)).format(formatDate[4]) 
                        + ' - ' + moment(new Date(arrSpeed.date_iso)).add(1, 'hour').format(formatDate[4]),
                        // SPEED: avg_excluding_zeros(arrSpeed.map(i => i.SPEED))
                        SPEED: arrSpeed.SPEED
                    } 
                    
                    // MAX SPEED / DAY
                    max = {
                        date_iso: moment(new Date(arrSpeed.date_iso)).format(formatDate[3]),
                        // SPEED: max_number(arrSpeed.map(i => i.SPEED))
                        SPEED: arrSpeed.MAX_SPEED
                    } 

                    // V85 SPEED / HOUR
                    v85 = {
                        date_iso: moment(new Date(arrSpeed.date_iso)).format(formatDate[4]) 
                        + ' - ' + moment(new Date(arrSpeed.date_iso)).add(1, 'hour').format(formatDate[4]),
                        // SPEED: percentil_85(arrSpeed.map(i => i.SPEED))
                        SPEED: arrSpeed.P85_SPEED
                    } 

                    // AVG SPEED / WEEKDAY
                    avgSpeedDay = {
                        date_iso: moment(new Date(arrSpeed.date_iso)).weekday(),
                        // SPEED: avg_excluding_zeros(arrSpeed.map(i => i.SPEED))
                        SPEED: arrSpeed.SPEED
                    } 

                    // AVG COUNT / DAY
                    avgCountDay = {
                        date_iso: moment(new Date(arrSpeed.date_iso)).format(formatDate[3]),
                        // VOLUME: count_non_zeros(arrSpeed.map(i => i.VOLUME))
                        VOLUME: arrSpeed.VOLUME
                    } 

                }

                if (avg.SPEED)
                    arrByHour = [...arrByHour, avg];

                if (max.SPEED)
                    arrByDayMaxSpeed = [...arrByDayMaxSpeed, max];

                if (v85.SPEED)
                    arrByHourV85 = [...arrByHourV85, v85];

                if (avgSpeedDay.SPEED)
                    arrByWeekDayAvgSpeed = [...arrByWeekDayAvgSpeed, avgSpeedDay];

                if (avgCountDay.VOLUME)
                    arrByDayAvgCount = [...arrByDayAvgCount, avgCountDay];
             
            }

        // SPEED VS TIME - START
            // array by hour 
            const hh = [...new Set(arrByHour.map(item => item.date_iso))];
            
            let groupByHour = []
            hh.map(item => {
                // return groupByHour.push({date: item, speed: avg_excluding_zeros(arrByHour.filter(i => i.date_iso === item).map(i => i.SPEED)) })
                return groupByHour.push({date: item, speed: avg_excluding_zeros(arrByHour.filter(i => i.date_iso === item).map(i => parseFloat(i.SPEED))) })
            })
    
            groupByHour = groupByHour.sort((a, b) => (a.date > b.date) ? 1 : -1)

            // console.log("groupByHour", groupByHour)

            const avg = {
                labels: groupByHour.map(i => i.date),
                datasets: [{
                    type: 'line',
                    label: 'Average Speed',
                    data: groupByHour.map(i => i.speed),
                    borderColor: [chartColors[10]],
                    backgroundColor: [hex2rgba(chartColors[10], 0.7)],
                    borderWidth: 2,
                    datalabels: {
                        display: false
                    }
                },
                ]
            }
            setSpeedTime(avg);
            setSpeedTimeTbl(groupByHour);
        // SPEED VS TIME - END

        // SPEED V85 HOUR - START
            // array by hour v85
            const hhv85 = [...new Set(arrByHourV85.map(item => item.date_iso))];

            let groupByHourV85 = []
            hhv85.map(item => {
                // console.log(percentil_85(arrByHourV85.filter(i => i.date_iso === item).map(i => parseFloat(i.SPEED))))
               return groupByHourV85.push({date: item, speed: percentil_85(arrByHourV85.filter(i => i.date_iso === item).map(i => parseFloat(i.SPEED))) })
            })

            const v85 = {
                labels: groupByHourV85.map(i => i.date),
                datasets: [{
                    type: 'line',
                    label: 'Percentil 85',
                    data: groupByHourV85.map(i => i.speed),
                    borderColor: [chartColors[1]],
                    backgroundColor: [hex2rgba(chartColors[1], 0.7)],
                    borderWidth: 2,
                    datalabels: {
                        display: false
                    }
                },
                ]
            }
            setSpeedV85(v85);
            setSpeedV85Tbl(groupByHourV85);
        // SPEED V85 HOUR - ENd

        // MAX SPEED DAY - START
            // array by day 
            const dd = [...new Set(arrByDayMaxSpeed.map(item => item.date_iso))];

            let groupByDay = []
            dd.map(item => {
                return groupByDay.push({date: item, speed: max_number(arrByDayMaxSpeed.filter(i => i.date_iso === item).map(i => i.SPEED)) })
            })
    
            groupByDay = groupByDay.sort((a, b) => (a.date > b.date) ? 1 : -1)

            // console.log("groupByDay", groupByDay)

            const max_speed = {
                labels: groupByDay.map(i => i.date),
                datasets: [{
                    type: 'bar',
                    label: 'Max Speed',
                    data: groupByDay.map(i => i.speed),
                    borderColor: [chartColors[10]],
                    backgroundColor: [hex2rgba(chartColors[10], 0.7)],
                    borderWidth: 2,
                    datalabels: {
                        display: false
                    }
                },
                ]
            }
            setMaxSpeed(max_speed);
            setMaxSpeedTbl(groupByDay);
        // MAX SPEED DAY - END

        // AVG SPEED WEEKDAY - START
            // array by day 
            const weekday = [...new Set(arrByWeekDayAvgSpeed.map(item => item.date_iso))];

            let groupByWeekDay = []
            weekday.map(item => {
                return groupByWeekDay.push({date: item, speed: max_number(arrByWeekDayAvgSpeed.filter(i => i.date_iso === item).map(i => i.SPEED)) })
            })
    
            groupByWeekDay = groupByWeekDay.sort((a, b) => (a.date > b.date) ? 1 : -1)

            const avg_speed_weekday = {
                labels: groupByWeekDay.map(i => WEEKDAY[i.date]),
                datasets: [{
                    type: 'bar',
                    label: 'Average Speed',
                    data: groupByWeekDay.map(i => i.speed),
                    borderColor: [chartColors[1]],
                    backgroundColor: [hex2rgba(chartColors[1], 0.7)],
                    borderWidth: 2,
                    datalabels: {
                        display: false
                    }
                },
                ]
            }
            setAvgSpeedWeekday(avg_speed_weekday);
            setAvgSpeedWeekdayTbl(groupByWeekDay);
        // AVG SPEED WEEKDAY - END

        // AVG COUNT DAY - START
            // // array by day 
            // const day = [...new Set(arrByDayAvgCount.map(item => item.date_iso))];

            // let groupCountByDay = []
            // day.map(item => {
            //     groupCountByDay.push({date: item, volume: count_non_zeros(arrByDayAvgCount.filter(i => i.date_iso === item).map(i => i.VOLUME)) })
            // })
    
            // groupCountByDay = groupCountByDay.sort((a, b) => (a.date > b.date) ? 1 : -1)

            // const avg_count_day = {
            //     labels: groupCountByDay.map(i => i.date),
            //     datasets: [{
            //         type: 'bar',
            //         label: 'Average Vehicles',
            //         data: groupCountByDay.map(i => Math.round(i.volume)),
            //         borderColor: [chartColors[1]],
            //         backgroundColor: [hex2rgba(chartColors[1], 0.7)],
            //         borderWidth: 2,
            //         datalabels: {
            //             display: false
            //         }
            //     },
            //     ]
            // }
            // setADT(avg_count_day);
        // AVG COUNT DAY - END

        }


    // VEHICLE COUNT START
    // --------------------------
        // Total vehicles count / hour
        const getVehicleCount = () => {

            // let countVh = [];
            let arrVeh = [];
            let arrVehAvg = [];


            for (let hh = 0; hh < 24; hh++){

                let dataHour = counts.filter(function(item){
                    let aDate = moment(new Date(item.date_iso)).format('HH');
                    return parseInt(aDate) === hh;
                })

                let veh = 0;

                // Agregate VOLUME by CLASS
                for (let x = 0; x < dataHour.length; x++){
                    //  veh += dataHour[x].entries.filter(item => {return (vehClass !== 'ALL')?(item.CLASS === vehClass):true
                    //   }).reduce((sum, item) => {return sum = sum + parseInt(item.VOLUME) }, 0);
                    veh += dataHour[x].VOLUME;
                }

                arrVeh.push(veh);
                arrVehAvg.push((numDays > 0 && Math.round(veh/numDays)) || 0)

            }

            // setVehTotalCount(arrVeh.reduce((sum, item) => {return sum = sum + item }, 0));
            const hrs = ['00:00-01:00','01:00-02:00','02:00-03:00','03:00-04:00','04:00-05:00','05:00-06:00'
            ,'06:00-07:00','07:00-08:00','08:00-09:00','09:00-10:00','10:00-11:00','11:00-12:00'
            ,'12:00-13:00','13:00-14:00','14:00-15:00','15:00-16:00','16:00-17:00','17:00-18:00'
            ,'18:00-19:00','19:00-20:00','20:00-21:00','21:00-22:00','22:00-23:00','23:00-24:00'
            ]

            // Graph bar, vehicle / hour
            const data = {
                labels: hrs,
                datasets: [
                {
                    type: 'bar',
                    label: 'Total Vehicles',
                    data: arrVeh,
                    borderColor: [chartColors[1]],
                    backgroundColor: [hex2rgba(chartColors[1], 0.7)],
                    borderWidth: 2,
                    datalabels: {
                        display: false
                    }
                }]

            }
            setVehicleCount(data);

            const vehCounts = []
            hrs.map((item, i) => vehCounts.push({
                date: item,
                count: arrVeh[i] || 0
            }))

            setVehicleCountTbl(vehCounts)

            // Graph bar, daily avg vehicle / hour
            const dataAvg = {
                labels: hrs,
                datasets: [
                {
                    type: 'bar',
                    label: 'Average Vehicles',
                    data: arrVehAvg,
                    borderColor: [chartColors[10]],
                    backgroundColor: [hex2rgba(chartColors[10], 0.7)],
                    borderWidth: 2,
                    datalabels: {
                        display: false
                    }
                }]

            }
            setADT(dataAvg);

            const avgCounts = []
            hrs.map((item, i) => avgCounts.push({
                date: item,
                count: arrVehAvg[i] || 0
            }))
            setADTTbl(avgCounts)

        }

    // VEHICLE COUNT END

        getAvgSpeed();
        getVehicleCount();

        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[counts, avg_excluding_zeros]);
    // SPEED END

    const hex2rgba = (hex, alpha = 1) => {
        const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
        return `rgba(${r},${g},${b},${alpha})`;
      };

    // VEHICLE COUNT START
    // --------------------------
    useEffect(() => {

        // Total vehicles count / hour
        const getVehicleCount = () => {

            if (counts.length >0){
                
            }
                
        }
        getVehicleCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[counts]);
    // VEHICLE COUNT END

    // Graph options
    const options = {
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        scales: {
            y: { ticks: { beginAtZero: true } },
        },
        // plugins: { 
        //     datalabels: { display: false }
        // }
    };

    // const options2 = {
    //     indexAxis: 'y',
    // }

    const handleClearSearch = () => {
		setTimeFrom(new Date().setHours(0,0,0));
        setTimeTo(new Date().setHours(23,59,0));
		setAsset('');
		setDateSel(new Date());
		setDateSelTo(new Date());
        setCounts([]);
        setVehicleCount({});

        if (countryList.length === 1)
            setCountry(countryList[0]);
        else
            setCountry('');

        setLocation('');
        setError('');
    }

    const handleSearch = () => {
        if (asset){
            fetchCounts();
        }else{
            setError("Required");
        }
    }

    return (

        <div className="SpeedReport">
            <div className="col-md-12">
                <div className="row header">Speed Report</div>
            </div>
            {(!isLoading) ? (
            <div>
            <div className="col-md-12 pt-0 div-content">
            <div className="row">
                <div className="col-12 p-2 d-flex rounded bg-light">
                    <div className="col-6">
                    <div className="row">
                        <div className="col-md-8">
                        <div className="row">
                            <div className="col-md-4">
                            <Form.Group controlId="country">
                                <Form.Label>Country</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={country}
                                    onChange={e => {setCountry(e.target.value)}}>
                                        <option value="">Country</option>
                                        {countryList.map((item, i) =>
                                            <option key={`country`+i} value={item}>{item}</option>
                                            )}

                                </Form.Control>
                            </Form.Group>
                            </div>
                            <div className="col-md-8">
                            <Form.Group controlId="location" >
                            <Form.Label>Location</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={location}
                                    onChange={e => {setLocation(e.target.value)}}>
                                        <option key='locs' value=''>Location</option>
                                        {locationList.map((item, i) =>
                                            <option key={`loc`+i} value={item}>{item}</option>
                                            )}
                                </Form.Control>
                            </Form.Group>
                            </div>
                            </div>
                            <Form.Group controlId="asset" >
                                <Form.Label>Asset</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={asset}
                                    onChange={e => {
                                        setError("");
                                        setAsset(e.target.value);}}
                                    >
                                    <option key='assetList' value=''>Select Asset</option>
                                    {assetList.map((item, i) =>
                                    <option key={item.id} value={item.id}>{item.name}</option>
                                    )}
                                </Form.Control>
                                <div className="error-message">{error}</div>
                            </Form.Group>
                        </div>
                        <div className="col-md-4">
                            <Form.Group controlId="date_from" className="pb-2 mb-1">
                            <Form.Label><FaCalendarAlt className="text-secondary" /> Date From</Form.Label>
                            {/* <Form.Label><FaCalendarAlt className="text-secondary" /> Select Year(s)</Form.Label> */}
                            <div>
                            <DatePicker
                                dateFormat={formatDate[1]}
                                selected={dateSel}
                                onChange={(dateSel) => {setDateSel(dateSel)}}
                                minDate={new Date(moment().add(-6, 'month'))}
                                maxDate={new Date()}
                                className="form-control" />
                            </div>
                            </Form.Group>
                            <Form.Group controlId="date_from" className="pb-2 mb-1">
                            <Form.Label><FaCalendarAlt className="text-secondary" /> Date To</Form.Label>
                            <div>
                            <DatePicker
                                dateFormat={formatDate[1]}
                                selected={dateSelTo}
                                onChange={(dateSelTo) => {setDateSelTo(dateSelTo)}}
                                minDate={new Date(moment().add(-6, 'month'))}
                                maxDate={new Date()}
                                className="form-control" />
                            </div>
                            </Form.Group>
                        </div>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="row">
                        <div className="col-md-12 pb-4">
                        <Button variant="info" size="sm" onClick={handleSearch} className="mr-1 text-nowrap"
                        disabled = {isLoadingCounts? true : false}
                        >
                            <MdSearch /> Search
                        </Button>

                        <Button variant="danger" size="sm" onClick={handleClearSearch} >
                            <MdClear />
                        </Button>
                        </div>
                        
                        <div className="col-md-12 pt-3">
                            <Form.Label></Form.Label>
                            <ToggleButtonGroup type="radio" name="options" id="btn-veh" value={vehClass} >

                                <ToggleButton variant="outline-warning" className="classTxt" value="ALL" onClick={() => setVehClass('ALL')} >
                                    All
                                </ToggleButton>
                                <ToggleButton variant="outline-warning" className="class" value="MOTORBIKE" onClick={() => setVehClass('MOTORBIKE')}>
                                    <OverlayTrigger  key="motorbike" placement="bottom"
                                        overlay={<Tooltip id='tooltip-motorbike' className="class-tooltip">Motorbike</Tooltip>}>
                                        <FaMotorcycle />
                                    </OverlayTrigger>
                                </ToggleButton>
                                <ToggleButton variant="outline-warning" className="class" value="CAR" onClick={() => setVehClass('CAR')}>
                                    <OverlayTrigger key="car" placement="bottom"
                                        overlay={<Tooltip id='tooltip-car' className="class-tooltip">Car</Tooltip>}>
                                        <FaCarSide />
                                    </OverlayTrigger>
                                </ToggleButton>
                                <ToggleButton variant="outline-warning" className="class" value="VAN" onClick={() => setVehClass('VAN')}>
                                    <OverlayTrigger key="van" placement="bottom"
                                        overlay={<Tooltip id='tooltip-van' className="class-tooltip">Van</Tooltip>} >
                                        <FaShuttleVan />
                                    </OverlayTrigger>
                                </ToggleButton>
                                <ToggleButton variant="outline-warning" className="class" value="SHORT TRUCK" onClick={() => setVehClass('SHORT TRUCK')}>
                                    <OverlayTrigger key="large-van" placement="bottom"
                                        overlay={<Tooltip id='tooltip-large-van' className="class-tooltip">Short Truck</Tooltip>} >
                                        <FaTruck />
                                    </OverlayTrigger>
                                </ToggleButton>
                                {vClass.find(x => x === 'Med Truck') ? 
                                <ToggleButton variant="outline-warning" className="class" value="MED TRUCK" onClick={() => setVehClass('MED TRUCK')}>
                                    <OverlayTrigger key="large-van" placement="bottom"
                                        overlay={<Tooltip id='tooltip-large-van' className="class-tooltip">Med Truck</Tooltip>} >
                                        <FaTruckPickup />
                                    </OverlayTrigger>
                                </ToggleButton>
                                :''}
                                <ToggleButton variant="outline-warning" className="class" value="LONG TRUCK" onClick={() => setVehClass('LONG TRUCK')}>
                                    <OverlayTrigger key="truck" placement="bottom"
                                        overlay={<Tooltip id='tooltip-truck' className="class-tooltip">Long Truck</Tooltip>} >
                                        <FaTruckMoving />
                                    </OverlayTrigger>
                                </ToggleButton>
                                {vClass.find(x => x === 'Bus') ? 
                                <ToggleButton variant="outline-warning" className="class" value="BUS" onClick={() => setVehClass('BUS')}>
                                    <OverlayTrigger key="large-van" placement="bottom"
                                        overlay={<Tooltip id='tooltip-large-van' className="class-tooltip">Bus</Tooltip>} >
                                        <FaBus />
                                    </OverlayTrigger>
                                </ToggleButton>
                                :''}
                                <ToggleButton variant="outline-warning" className="class" value="UNDEFINED" onClick={() => setVehClass('UNDEFINED')}>
                                    <OverlayTrigger key="undefined" placement="bottom"
                                        overlay={<Tooltip id='tooltip-undefined' className="class-tooltip">Undefined</Tooltip>}>
                                        <FaRegQuestionCircle />
                                    </OverlayTrigger>
                                </ToggleButton>
                            </ToggleButtonGroup>
                                
                            </div>
                            </div>
                    </div>
                    <div className="w-100 text-right print">
                        <SpeedReportXls
                            speedTime={speedTimeTbl}
                            speedV85={speedV85Tbl}
                            maxSpeed={maxSpeedTbl}
                            avgSpeedWeekday={avgSpeedWeekdayTbl}
                            adt={adtTbl}
                            vehicleCount={vehicleCountTbl}
                            dateFrom={dateSel}
                            dateTo={dateSelTo}
                            asset={assetName}
                            vehClass={vehClass}
                            />
                        <Button variant="light" size="sm" onClick={() => window.print()} >
                            <FaPrint /> Print
                        </Button>
                    </div>
                </div>
                </div>

                <div className="row p-2">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12 text-center">
                            {(isLoadingCounts) ? (
                            <>
                            <Spinner animation="grow" size="sm" role="status" variant="warning" />
                            <span className="text-secondary">  Loading...</span>
                            </>
                         ): ''}
                            </div>
                            <div className="col-md-4 pb-2 small text-right text-secondary">
                                {/* &nbsp;&nbsp;Last Update: {lastUpd} */}
                            </div>
                        </div>
                        <div className="row">
                            {(speedTime.datasets && speedTime.datasets.length > 0)?
                            <div className="col-md-12">
                                <h2>Within {numDays} days {(vehClass !=='ALL')? ' - ' + vehClass :''}</h2>                          
                            </div>
                            :''}

                            <div className="col-md-12 pb-3">
                            <h2 className="text-header">Speed vs Time</h2>
                            <div className="text-description small pb-3">
                                average speed per hour over the selected period
                            </div>
                            {(speedTime.datasets && speedTime.datasets.length > 0)?
                            <Graph
                                title="Speed vs Time"
                                data={speedTime}
                                options={options}
                                site={assetName}
                            />
                            :''}
                            </div>
                            <div className="col-md-12 pb-3">
                            <h2 className="text-header">Speed V85</h2>
                            <div className="text-description small pb-3">
                                percentil 85 per hour over the selected period.
                                {/* <br/>V85 refers to a principle on vehicle traffic law where the legal speed limit of a motorway is set such that 15% of drivers exceed the limit. */}
                            </div>
                            {(speedV85.datasets && speedV85.datasets.length > 0)?
                            <Graph
                                title="Speed V85"
                                data={speedV85}
                                options={options}
                                site={assetName}
                            />
                            :''}
                            </div>
                            <div className="col-md-12 pb-3">
                            <h2 className="text-header">Max Speed</h2>
                            <div className="text-description small pb-3">
                                maximum speed registered each day of the selected period
                            </div>
                            {(maxSpeed.datasets && maxSpeed.datasets.length > 0)?
                            <Graph
                                title="Max Speed"
                                data={maxSpeed}
                                options={options}
                                site={assetName}
                            />
                            :''}
                            </div>
                            <div className="col-md-12 pb-3">
                            <h2 className="text-header">Speed vs Weekday</h2>
                            <div className="text-description small pb-3">
                                average speed for each day of the week over the selected period
                            </div>
                            {(avgSpeedWeekday.datasets && avgSpeedWeekday.datasets.length > 0)?
                            <Graph
                                title="Speed vs Weekday"
                                data={avgSpeedWeekday}
                                options={options}
                                site={assetName}
                            />
                            :''}
                            </div>
                            <div className="col-md-12 pb-3">
                            <h2 className="text-header">Records vs time</h2>
                            <div className="text-description small pb-3">
                                total vehicle count per hour in the selected period
                            </div>
                            {(vehicleCount.datasets && vehicleCount.datasets.length > 0)?
                            <Graph
                                title="Records vs time"
                                data={vehicleCount}
                                options={options}
                                site={assetName}
                            />
                            :''}
                            </div>
                            <div className="col-md-12">
                            <h2 className="text-header">Average Daily Traffic (ADT)</h2>
                            <div className="text-description small pb-3">
                                average hourly vehicle count for the selected period
                            </div>
                            {(adt.datasets && adt.datasets.length > 0)?
                            <Graph
                                title="Average Daily Traffic (ADT)"
                                data={adt}
                                options={options}
                                site={assetName}
                            />
                            :''}
                            </div>

                        </div>
                    </div>
                </div>

            </div>
            </div>
            ):(
                <div className="col-md-12">
                <Spinner animation="grow" size="sm" role="status" variant="warning" />
                <span className="text-dark">  Loading...</span>
                </div>
                )}
        </div>
    )
}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        formatDate: state.auth.formatDate,
    };
  };

export default connect(mapStateToProps)(SpeedReport);


